import { FabriqVault } from "@/classes/FabriqVault";

const vault = new FabriqVault();

export default vault;
